import { ChatQuickReplyMessage, ChatQuickReplyMessageConnectionInput, SortDirectionEnum } from '@/models/gen/graphql';
import { QueryInputType, queryInput } from '@/utils';

import { SearchChatQuickReplyMessageDocument } from '@/api/queries';
import graphApi from '@/api';

const [, runRefetchQuickReplyTemplates] = graphApi(SearchChatQuickReplyMessageDocument);
const PAGE_SIZE = 1000;

export const searchQuickReplyTemplates = async (): Promise<ChatQuickReplyMessage[]> => {
  const input: ChatQuickReplyMessageConnectionInput = {
    first: PAGE_SIZE,
    after: null,
    query: [
      {
        sortOrder: queryInput([], QueryInputType.DEFAULT, SortDirectionEnum.Asc),
      },
    ],
  };

  const res = await runRefetchQuickReplyTemplates({ input });
  const connection = res?.searchChatQuickReplyMessage?.chatQuickReplyMessageConnection;

  return connection?.edges?.map((edge) => edge?.node) || [];
};
